import React from "react";
import { motion } from "framer-motion";
import { stats } from "../Data";
import Bg from "../Images/stats-bg.webp";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.2,
    },
  },
};

const cardVariant = {
  hidden: {
    opacity: 0,
    y: 60,
    scale: 0.9,
    filter: "blur(10px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    filter: "blur(0px)",
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const fadeRight = {
  hidden: {
    opacity: 0,
    x: 80,
    filter: "blur(10px)",
  },
  visible: {
    opacity: 1,
    x: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const StatItem = ({ stat, index }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.35,
  });

  return (
    <motion.div
      ref={ref}
      className="stat-card"
      variants={cardVariant}
      whileHover={{
        y: -10,
        scale: 1.03,
        rotateX: 3,
        rotateY: index % 2 === 0 ? -3 : 3,
      }}
      transition={{
        type: "spring",
        stiffness: 260,
        damping: 18,
      }}
    >
      <motion.h3
        className="card-heading"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
      >
        <motion.span
          animate={{
            textShadow: [
              "0px 0px 0px rgba(15,174,77,0)",
              "0px 0px 12px rgba(15,174,77,.35)",
              "0px 0px 0px rgba(15,174,77,0)",
            ],
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
          }}
        >
          {stat.prefix}

          {inView && (
            <CountUp
              end={stat.value}
              duration={2.5}
            />
          )}

          {stat.suffix}
        </motion.span>

        <br />

        {stat.title}
      </motion.h3>

      <motion.p
        className="section-text"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.25 }}
      >
        {stat.desc}
      </motion.p>
    </motion.div>
  );
};

const StatsSection = () => {
  return (
    <section
      className="stats-section"
      style={{ backgroundImage: `url(${Bg})` }}
    >
      <motion.div
        className="stats-bg-glow"
        animate={{
          scale: [1, 1.15, 1],
          opacity: [0.4, 0.8, 0.4],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      <div className="container">

        <div className="stats-wrapper">

          <motion.div
            className="stats-grid"
            variants={container}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.2,
            }}
          >
            {stats.map((item, index) => (
              <StatItem
                key={item.id}
                stat={item}
                index={index}
              />
            ))}
          </motion.div>

          <motion.div
            className="stats-content"
            variants={fadeRight}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.4,
            }}
          >
            <h2 className="section-heading">
              WhatsApp is where your <br />customers already are
            </h2>

            <p className="section-text">
              These numbers explain why every business needs a WhatsApp
              strategy—not just a phone number—to drive engagement,
              build trust, and increase conversions.
            </p>
          </motion.div>

        </div>

      </div>
    </section>
  );
};

export default StatsSection;